import MasterData from '@/js/services/contracts/MasterData';

export const mapContractToERP = (contract) => {
  const Lines = [];
  contract.lines.forEach((l) => {
    const DataComplementary = [];
    if (l.dcs) {
      const codes = Object.keys(l.dcs);
      codes.forEach((code) => {
        DataComplementary.push({
          Code: code,
          Value: l.dcs[code],
        });
      });
    }

    const lineERP = {
      Id: 0,
      Article: l.variety,
      Price: l.price,
      Quantity: l.quantity,
      Amount: l.amount,
      PriceType: l.priceType,
      DataComplementary,
      Field: contract.field.code,
    };
    Lines.push(lineERP);
  });

  const Images = [];
  if (Object.hasOwn(contract, 'images')) {
    contract.images.forEach((i) => {
      let image64 = '';
      if (i.split('data:image/png;base64,').length > 1) {
        [, image64] = i.split('data:image/png;base64,');
      } // Posición 1
      if (i.split('data:image/jpeg;base64,').length > 1) {
        [, image64] = i.split('data:image/jpeg;base64,');
      } // Posición 1
      Images.push({
        name: 'ImagenContrato',
        image: image64,
      });
    });
  }

  // La firma se guarda como una imagen.
  if (contract.signature && contract.signature !== '') {
    Images.push({
      name: '#Firma',
      image: contract.signature.split('data:image/jpeg;base64,')[1],
    });
  }

  const contractERP = {
    Id: contract.id_external || 0,
    Date: contract.startDate,
    StartDate: contract.startDate,
    EndDate: contract.endDate,
    Provider: contract.field.farmer.code,
    State: (contract.state !== undefined) ? contract.state : 1,
    Lines,
    Images,
    SendEmail: (contract.sendEmail === undefined) ? false : contract.sendEmail,
  };

  return contractERP;
};

export const mapERPContractToLocal = async (contractERP) => {
  const field = await MasterData.getByKey('fields', 'code', contractERP.field);
  if (field.length === 0) {
    return null;
  }
  contractERP.lines.forEach((line) => {
    const dcs = {};
    line.dcs.forEach((dc) => {
      dcs[dc.code] = dc.value;
    });
    line.dcs = dcs;
  });
  const contract = { ...contractERP };
  contract.startDate = contract.startDate.split('T')[0] || contract.startDate;
  contract.endDate = contract.endDate.split('T')[0] || contract.endDate;
  contract.field = field[0].id;
  contract.sync_status = 0;

  return contract;
};
